<template>
	<div class="sl-editor" :id="attributeName + '__area'">
		<div class="col-sm-5">
			<AttributeLabel
				:attributeName="attributeName"
				:localizedTitle="localizedTitle"
				:is-primary="isPrimary"
				:is-multiple="isMultiple"
				:max-count="maxCount"
				:sl-attribute="true"
				:enable-copy-attribute-name="enableCopyAttributeName"
				:lang="language"
				:index="index"
				:is-prev=true
				:locked-edit="lockedEdit"
			/>
		</div>
		<div class="col-sm-7">
			<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
				<div :class="SINGLE_ATTRIBUTE + ' ' + PREV_VALUES_DICT_CLASS">
					<PrevValuesDictionaryList
						:attributeName="attributeName"
						:is-multiple="true"
						:max-length="maxLength"
						:lang="language"
						:index="index"
						:item-data="itemData"
						:prev-values-dictionary="prevValuesDictionary"
						:locked-edit="lockedEdit"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import { Fragment } from 'vue-fragment'
import PrevValuesDictionaryList from './PrevValuesDictionaryList'
import defaultClassManager from '../../mixins/defaultClassManager'

export default {
	components: {
		AttributeLabel,
		Fragment,
		PrevValuesDictionaryList
	},
	mixins: [defaultClassManager],
	name: 'SLPrevValuesDictionaryEditor',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxLength',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'language',
		'index',
		'prevValuesDictionary',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	data () {
		return {
			SINGLE_ATTRIBUTE: 'single-attribute',
			PREV_VALUES_DICT_CLASS: 'pr-val-dict'
		}
	},
	directives: {
		bindShowLangsList: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'showLangsList(\'' + binding.value + '\', null);')
			}
		},
		bindCopyComponentSL: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'copyComponentSL(\'' + binding.value + '\');')
			}
		},
		bindHideLangsList: {
			inserted: function (el, binding) {
				el.setAttribute('onblur', 'hideLangsList(\'' + binding.value + '\');')
			}
		},
		bindCopyToClipboard: {
			inserted: function (el, binding) {
				el.setAttribute('onclick', 'CopyToClipboard(\'' + binding.value + '\', this)')
			}
		}
	}
}
</script>

<style scoped>
	.form .form-body .tab-content .right-float-button.button_minus {
		padding-right: 0;
	}
</style>
